import { Injectable } from '@angular/core';
import { LoggerService } from '../shared/logger/logger.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getDataName } from '../shared/utils';
import { environment } from '../../environments/environment';

/**
 * Measurement service, handle measurement-related http requests
 */
@Injectable()
export class MeasurementsService {

  /**
   * Default constructor
   * @param {HttpClient} http - refined http service, automatically adds authentication token
   * @param {LoggerService} logger - logger service
   */
  constructor(private http: HttpClient, private logger: LoggerService) {
  }

  /**
   * Fetch history measurements for given map object
   * @param mapObjectID
   * @returns {Observable<any[]>}
   */
  getMeasurementsForFeature(mapObjectID: string, tenant: number): Promise<any[]> {
    return this.http.get<any[]>(environment.dataApiURL + getDataName(tenant) + 'Measurements?name=/QTI/&deviceId=HK521&eventType!=Aikaleima&eventType!=unknown_event&eventType!=Tilatieto&sort=-ts').toPromise();
  }

  getMeasurementsForName(name: string): Promise<any[]> {
    return this.http.get<any[]>(environment.dataApiURL + '?collectionName=' + name + 'Aggregates_min5&sort=-createdAt&limit=4000').toPromise();
  }

}
